export default __webpack_public_path__ + "static/media/5.16d8d9c1.jpg";